import { useBrPageContext } from "../../context/context/context.js";
import { getConfiguratorDocument } from "../../utils/utils/get-configurator-document.js";
import { getSizeGuideDocument } from "../../utils/utils/get-size-guide-document.js";
import { getBrandPromotions } from "../../utils/utils/get-brand-promotions.js";
import { getPurchaseTypes } from "../../utils/utils/get-purchase-types.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const emptyContent = {};
function useBloomreachPdpContent() {
  const page = useBrPageContext();
  if (!page) {
    return emptyContent;
  }
  const reference = page.getComponent("main")?.getModels()?.document;
  if (!reference) {
    return emptyContent;
  }
  if (!reference.$ref) {
    return emptyContent;
  }
  const content = getBrPageContent(page, reference);
  if (!content) {
    console.warn(
      `Cannot find main content for ProductDetail BR page. Got: ${content} for $ref: ${reference.$ref}`
    );
    return emptyContent;
  }
  const {
    usps,
    instructions,
    noAddonsImage,
    additionalUsps,
    disclaimer,
    configuratorDocument: configuratorDocumentRef,
    sizeGuideDocument: sizeGuideDocumentRef,
    brandCollectionDocument,
    purchaseTypeContainer
  } = content;
  const confDocContent = getBrPageContent(page, configuratorDocumentRef);
  const configuratorDocument = getConfiguratorDocument(confDocContent, noAddonsImage || void 0);
  const sizeGuideDocContent = getBrPageContent(page, sizeGuideDocumentRef);
  const sizeGuideDocument = getSizeGuideDocument(sizeGuideDocContent);
  const mainComponent = page.getComponent("main");
  const modal = getModalContent(mainComponent, page);
  const brandCollection = getBrPageContent(page, brandCollectionDocument);
  const brandPromotions = getBrandPromotions(brandCollection?.brands);
  const purchaseTypeDocument = getPurchaseTypes(purchaseTypeContainer);
  const disclaimerResult = disclaimer ? {
    name: disclaimer.name,
    displayName: disclaimer.displayName,
    title: disclaimer.title,
    description: disclaimer.description,
    contentType: disclaimer.contentType
  } : void 0;
  return {
    modalContent: modal?.content?.value ?? "",
    instructions: instructions && {
      value: instructions.html,
      textColor: instructions.textColor,
      backgroundColor: instructions.backgroundColor
    },
    usps: usps.map(({ icon, text }) => ({ icon, text })),
    additionalUsps: additionalUsps.map(({ icon, text }) => ({ icon, text })),
    configuratorDocument,
    purchaseTypeDocument,
    brandPromotions,
    disclaimer: disclaimerResult,
    sizeGuideDocument
  };
}
function getModalContent(main, page) {
  const components = main?.getChildren()?.reduce((acc, cur) => {
    return cur?.getChildren() ? [...acc, ...cur?.getChildren()] : acc;
  }, []);
  const modal = (components || []).find((c) => {
    return c.getName() === "richtext" && c.getParameters()?.template === "modal";
  });
  return page && getBrPageContent(page, modal?.getModels()?.document);
}
export {
  useBloomreachPdpContent
};
//# sourceMappingURL=use-bloomreach-pdp-content.js.map
